export default [
  {
    groupTitle: 'Do you want to receive email notifications for all customer transactions?',
    list: [
      {id: 'transaction_for_customer', text: 'Yes'}
    ]
  },
  {
    groupTitle: 'Do you want to receive email notifications for all payouts and settlements?',
    list: [
      {id: 'payouts_and_settlements', text: 'Yes'}
    ]
  },
  {
    groupTitle: 'Do you want to receive email notification for Pay by Link?',
    list: [
      {id: 'invoice_created', text: 'I want an email notification when a payment link is generated.'},
      {id: 'invoice_paid', text: 'I want an email notification when a payment link is paid.'},
      {id: 'invoice_cancelled', text: 'I want an email notification when a payment link is canceled.'},
      {id: 'invoice_expired', text: 'I want an email notification when a payment link has expired.'}
    ]
  },
  {
    groupTitle: 'Do you want to receive email notifications for account activities?',
    list: [
      {id: 'currency_added', text: 'I want an email notification when a new currency is added.'},
      {id: 'bank_added', text: 'I want an email notification when a new bank account is added.'},
      {id: 'terminal_ordered', text: 'I want an email notification when a new POS terminal is ordered.'}
    ]
  },
  {
    groupTitle: 'Do you want to receive email notifications for refunds?',
    list: [
      {id: 'refund_created', text: 'I want an email notification when a customer provides information for a refund.'},
      {id: 'refund_completed', text: 'I want an email notification when a refund is completed.'},
    ]
  },
];
